import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  TextField,
  Button,
  Alert,
} from "@mui/material";
import {
  getAnswersOfUser,
  saveAnswers,
} from "../../../services/rest/users/medicalQuestions";
import { handleError } from "../../../utils/handleError";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";

const PhysicalQuestionsModal = ({
  open,
  setOpen,
  setLoading,
  answers,
  setAnswers,
}) => {
  const { _id } = useSelector((state) => state.userReducer);
  const [questionsData, setQuestionsData] = React.useState({
    lesiones: answers?.lesiones ?? "Ninguna",
    molestiasDolor: answers?.molestiasDolor ?? "No",
    diagnosticosOrt: answers?.diagnosticosOrt ?? "No",
    ejerciciosMov: answers?.ejerciciosMov ?? "No",
    calzado: answers?.calzado ?? "",
    sesionesDep: answers?.sesionesDep ?? "No",
  });
  const [error, setError] = React.useState("");
  const onClose = () => {
    setOpen(false);
  };
  const handleChange = (field) => (event) => {
    setQuestionsData({ ...questionsData, [field]: event.target.value });
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      setError("");

      const answersFormat = {
        section: "fisico",
        userAnswers: questionsData,
      };
      await saveAnswers(answersFormat);
      const responseAnswers = await getAnswersOfUser(_id);
      // console.log("responses", responseAnswers);
      setAnswers(responseAnswers ?? {});
      setLoading(false);
      toast.success("Se guardaron con éxito sus respuestas");
      onClose();
    } catch (error) {
      const { message } = handleError(error);
      toast.error(
        `En estos momentos no se pudo guardar sus respuestas. \n ${message}`
      );
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={() => onClose(false)} maxWidth="xs" fullWidth>
      <DialogTitle>Información Física</DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={3} sx={{ pt: 2 }}>
          {error && (
            <Grid item xs={12}>
              <Alert severity="error">{error}</Alert>
            </Grid>
          )}

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="¿Has tenido lesiones deportivas previas? (Fracturas, esguinces, etc.)"
              value={questionsData.lesiones}
              onChange={handleChange("lesiones")}
              multiline
              rows={2}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="¿Sufres de dolor o molestias actuales? (¿Dónde y en qué situaciones?)"
              value={questionsData.molestiasDolor}
              onChange={handleChange("molestiasDolor")}
              multiline
              rows={3}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="¿Tienes algún diagnóstico ortopédico o muscular? (Escoliosis, hernias, etc.)"
              value={questionsData.diagnosticosOrt}
              onChange={handleChange("diagnosticosOrt")}
              multiline
              rows={2}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="¿Realizas ejercicios de movilidad o estiramientos regularmente?"
              value={questionsData.ejerciciosMov}
              onChange={handleChange("ejerciciosMov")}
              multiline
              rows={2}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="¿Qué tipo de calzado utilizas para correr? (Marca, modelo, tipo de soporte)"
              value={questionsData.calzado}
              onChange={handleChange("calzado")}
              multiline
              rows={2}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="¿Has tenido sesiones previas de fisioterapia? (Motivo y resultados)"
              value={questionsData.sesionesDep}
              onChange={handleChange("sesionesDep")}
              multiline
              rows={3}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose()} variant="outlined" color="white">
          Cancelar
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          sx={{ backgroundColor: "#e7ef7d" }}
        >
          Guardar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PhysicalQuestionsModal;
